import { render } from "./ApproximateWarning.vue?vue&type=template&id=1b83dba8"
import script from "./ApproximateWarning.vue?vue&type=script&lang=js"
export * from "./ApproximateWarning.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ApproximateWarning.vue?vue&type=style&index=0&id=1b83dba8&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/driver/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__